<template>
  <div style="background-color: white">
    <template>
      <ChatComponent />
      <ModalRegistrarmeComponent :modal="modalRegistro" @cerrar="cerrarModalRegistro()" />
      <v-img src="" class="padding-hero hero-gradient" style="background-color: #f6f6f6;">
        <v-row class="pb-" v-if="!$vuetify.breakpoint.xs && !$vuetify.breakpoint.sm">
          <v-col cols="12" lg="8" md="8" sm="8" class="pr-0">
            <v-row class="margen-arriba" style="margin-left: 10px">
              <v-col cols="12">
                <!-- text-h2 font-weight-bold -->
                <v-card-title class="custom-title-text text-primary-color text-center text-md-start px-0"
                  style="word-break: break-word">
                  <div>
                    <h4>Ofertas de</h4>
                    <h4>empleo</h4>
                  </div>
                </v-card-title>
              </v-col>
              <v-col cols="12" lg="8" md="8" sm="12" xl="8" class="mt-16">
                <div class="search-container d-flex align-center mb-10">
                  <v-text-field flat rounded solo v-model="search.categoria" placeholder="Ingresa tu búsqueda" clearable
                    @click:clear="getListOfertasEmpleos()" @keypress="validarTecla" @input="validarCategoria"
                    @paste="handlePaste" class="search-input" hide-details></v-text-field>
                  <v-btn dark rounded @click="buscar(search)" class="search-button" color="#22234a">
                    Buscar empleo
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" lg="2" md="5" sm="12" xl="2" style="margin-left: -260px" class="align-self-end"
            v-if="$vuetify.breakpoint.lg">
            <div class="d-flex justify-start align-end ml-5 pl-0" :style="imgDimension">
              <v-img src="../../assets/img/ImagenOfertasDeEmpleo.svg"> </v-img>
            </div>
          </v-col>
          <v-col cols="12" lg="2" md="5" sm="12" xl="2" style="margin-left: -350px" class="align-self-end"
            v-else-if="$vuetify.breakpoint.xl">
            <div class="d-flex justify-start align-end ml-5 pl-0" :style="imgDimension">
              <v-img src="../../assets/img/ImagenOfertasDeEmpleo.svg" max-height="1000" max-width="750">
              </v-img>
            </div>
          </v-col>
          <v-col cols="12" lg="2" md="5" sm="2" xl="2" style="margin-left: -180px" class="align-self-end"
            v-else-if="$vuetify.breakpoint.md">
            <div class="d-flex justify-start align-end ml-5 pl-0" :style="imgDimension">
              <v-img src="../../assets/img/ImagenOfertasDeEmpleo.svg"> </v-img>
            </div>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col cols="12" sm="12">
            <v-row>
              <v-col cols="12" class="pb-0 d-flex justify-center justify-md-start">
                <v-card-title class="text-h4 font-weight-bold text-primary-color text-center text-md-start"
                  style="word-break: break-word">
                  Ofertas de empleo
                </v-card-title>
              </v-col>
              <v-col cols="12" sm="12" class="pt-0 pb-0">
                <v-img src="../../assets/img/ImagenOfertasDeEmpleo.svg" :style="imgDimension">
                </v-img>
              </v-col>
              <v-col cols="12" class="pb-0 pt-0">
                <div class="search-container d-flex align-center mb-4">
                  <v-text-field flat rounded solo v-model="search.categoria" placeholder="Ingresa tu búsqueda" clearable
                    @click:clear="getListOfertasEmpleos()" @keypress="validarTecla" @input="validarCategoria"
                    @paste="handlePaste" class="search-input" hide-details></v-text-field>
                  <v-btn dark rounded @click="buscar(search)" class="search-button" color="#22234a">
                    Buscar empleo
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-img>
    </template>
    <v-row class="ml-3 mr-3">
      <!--Seccion filtros -->
      <v-col cols="12" class="mt-6">
        <v-card flat>
          <v-row style="margin-right: 0 !important"> </v-row>
          <v-row class="mt-10">

          </v-row>
        </v-card>
      </v-col>
      <!--Seccion ofertas de empleo -->
      <v-col cols="12">
        <!-- Sugerencias de empleos-->
        <template>
          <v-card flat>
            <div v-if="!token" class="centra-movil">
              <p class="text-h6">
                Para acceder a las mejores oportunidades de empleo
                personalizadas y disfrutar de todas las ventajas de nuestra
                plataforma, te invitamos a
                <a target="_blank" style="color: #1c1e4d" class="font-weight-bold" @click="
                  goToIdentidadDigital(
                    `${BASE_URL_ID}/oauth/authorize?response_type=code&client_id=${CLIENT_ID}&redirect_uri=${REDIRECT_URL.replace(
                      '/',
                      '%2F'
                    )}`
                  )
                  "><u>registrarte</u></a>
                o
                <a @click="iniciarSesion()" class="font-weight-bold" style="color: #1c1e4d" target="_blank"><u>iniciar
                    sesión</u></a>. Con una cuenta, podrás crear un perfil profesional,recibir
                sugerencias de empleo específicas para ti y mucho más
              </p>
            </div>
          </v-card>
        </template>
        <!-- ofertas  de empleos-->
        <template>
          <v-card flat>
            <v-row>
              <v-col cols="12">
                <v-toolbar-title class="mt-15 text-wrap" style="color: #1c1e4d">
                  <div class="custom-subtitle-text">
                    <div>
                      <b>Sugerencias de empleos disponibles</b>
                    </div>
                  </div>
                </v-toolbar-title>
              </v-col>
            </v-row>
            <v-row class="mt-12" dense>
              <v-col cols="12" sm="12" md="3" lg="2">
                <AppFiltro
                  nombreRuta="oferta-empleo"
                  :instituciones="instituciones"
                  :establecimientos="establecimientos"
                  :areasInteres="areaInteres"
                  @actualizar-filtro="onActualizarFiltro"
                  @limpiar-filtro="onLimpiarFiltro"
                />
              </v-col>
              <v-col cols="12" sm="12" md="9" lg="10">
                <v-row class="d-flex justify-center">
                  <v-col v-for="postulacion in ListOfertaEmplos" :key="postulacion.id" cols="12">
                    <CardSugerencias :item="postulacion" :favoritos="false" :persona="persona"
                      v-on:actualizarOfertas="actualizarCards" @on-click-detalle="goToDetalle"
                      @on-click-favorito="gestionarFavorito" />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </template>
      </v-col>
      <!-- Seccion paginacion -->
      <v-col cols="12" lg="12" md="12" sm="12" v-if="ListOfertaEmplos.length !== 0">
        <div class="text-center">
          <AppPaginationPlus v-model="pagina" :total-pages="totalPages > 0 ? totalPages : 1"
            @change="getListOfertasEmpleos" @perPageChange="changePerPage" :selectorPerPage="false" />
        </div>
      </v-col>
    </v-row>
    <app-loader v-if="loading"></app-loader>
  </div>
</template>

<script>
import CardEmpleo from "../../components/CardEmpleo.vue";
import foorter from "../../components/AppFooter.vue";
import ChatComponent from "../../components/ChatComponent.vue";
import { mapMutations, mapState } from "vuex";
import jwtDecode from "jwt-decode";
import AppLoader from "@/components/AppLoader.vue";
import AppPaginationPlus from "../../components/AppPaginationPlus.vue";
import CardSugerencias from "../../components/CardSugerencias.vue";
import ModalRegistrarmeComponent from "../landingPage/components/modalRegistrarmeComponent.vue";
import AppFiltro from "@/components/AppFiltro.vue";
export default {
  components: {
    CardEmpleo,
    foorter,
    ChatComponent,
    AppLoader,
    CardSugerencias,
    ModalRegistrarmeComponent,
    AppFiltro
  },
  data() {
    return {
      itemsCards: [],
      persona: 8,
      loading: false,
      page: 1,
      empleos: "56",
      fechaSelect: null,
      dataPersona: {},
      token: null,
      per_page: 8,
      pagina: 1,
      paginacion: false,
      totalRegistros: null,
      selectedArea: null,
      ListOfertaEmplos: {},
      ListOfertaEmplosSugeridos: [],
      areaInteres: [],
      instituciones: [],
      establecimientos: [],
      search: {
        categoria: null,
        id_area_interes: null,
        id_institucion: null,
        id_establecimiento: null,
        fecha_inicio_publicacion: null,
        fecha_fin_publicacion: null
      },
      REDIRECT_URL: process.env.VUE_APP_ID_REDIRECT_URL,
      BASE_URL_ID: process.env.VUE_APP_IDENTIDAD_DIGITAL_URL,
      CLIENT_ID: process.env.VUE_APP_CLIENT_ID,
      date: [],
      dateFormatted: null,
      menu1: false,
      windowWidth: window.innerWidth,
      debounceTimer: null,
      modalRegistro: false,
    };
  },
  computed: {
    ...mapState(["userInfo"]),
    imgDimension() {
      if (this.$vuetify.breakpoint.lgAndUp) {
        return "width: 618px; height: 556px;";
      }
      if (this.$vuetify.breakpoint.sm) {
        return "width: 50%; height: auto; margin-left: 25%; margin-right: 25%;";
      }
      return "width: auto; height: auto";
    },
    screenWidth() {
      return this.windowWidth;
    },
    dinamicCols() {
      if (this.screenWidth <= 1650) {
        return 4;
      }
      return 3;
    },
    totalPages() {
      // Validar que los valores existan y sean números válidos
      if (!this.totalRegistros || !this.per_page || this.per_page <= 0) {
        return 1; // Valor por defecto válido
      }

      const totalPaginas = Math.ceil(this.totalRegistros / this.per_page);

      // Asegurar que el resultado sea al menos 1
      return Math.max(totalPaginas, 1);
    },
    fechaMaxima() {
      return this.$moment().format("YYYY-MM-DD");
    }
  },
  methods: {
    ...mapMutations(["setUserInfo"]),
    // async getPersona() {
    //     const response = await this.services.datosPersona.getDatosPersona(this.persona)
    //     const data = {
    //         // nombres: response.data.primer_nombre + response.data.segundo_nombre
    //         nombres:`${response.data.primer_nombre} ${response.data.segundo_nombre}`,
    //         apellidos:`${response.data.primer_apellido} ${response.data.segundo_apellido ? response.data.segundo_apellido : response.data.apellido_casada}`
    //     }
    //     this.setUserInfo(data)

    // },
    async changePerPage(per_page) {
      this.loading = true;
      this.per_page = per_page;
      await this.getListOfertasEmpleos();
      this.loading = false;
    },
    async gestionarFavorito(item) {
      if (!this.usuarioAutenticado()) {
        this.modalRegistro = true;
        return;
      }
      if (this.isTokenValido(this.token)) {
        this.loading = true;
        const body = {
          id_oferta: item,
          id_persona: this.userInfo.id_persona
        };
        try {
          const response = await this.services.favoritos.putFavorito(body);
          if (response.status === 201) {
            this.message = response.data.message;
            this.loading = false;
            if (this.dataPersona?.hasOwnProperty("id")) {
              //await this.getListOfertasEmpleosSugeridos();
              await this.getListOfertasEmpleos();
            }
          }
        } catch (e) {
          let errorMessage = "Ocurrió un error";
          if (e.response && e.response.data && e.response.data.err) {
            errorMessage =
              e.response.data.err.message || e.response.data.err.description;
          }
          this.temporalAlert({
            show: true,
            type: "error",
            message: errorMessage
          });
        } finally {
          setTimeout(() => { }, 100);
        }
      } else {
        this.temporalAlert({
          show: true,
          type: "error",
          message: "El token ya expiró, debe de volver a iniciar sesión"
        });
        this.$router.replace({ name: "login" });
      }
    },
    handleFavorito(item) {
      //console.log('emit')
    },
    async actualizarCards() {
      this.loading = true;
      try {
        //await this.getListOfertasEmpleosSugeridos();
        await this.getListOfertasEmpleos();
        setTimeout(() => {
          this.loading = false;
        }, 500);
        //aqui debemos renderizar
      } catch (error) {
        // console.log("error")
      }
    },
    goToDetalle(id) {
      this.$router.push("/empleo/" + id);
    },
    async manejarCambioQuery(query) {
      const nombreArea = query.area;
      let busquedaEjecutada = false;

      if (nombreArea) {
        const areaEncontrada = this.areaInteres.find(
          (area) => area.nombre_area.toLowerCase() === nombreArea.toLowerCase()
        );

        if (areaEncontrada) {
          this.search.id_area_interes = areaEncontrada.id;
          await this.buscar(this.search);
          busquedaEjecutada = true;
        } else {
          await this.mostrarAlertaAreaNoEncontrada(nombreArea);
        }
      }
      return busquedaEjecutada;
    },
    async mostrarAlertaAreaNoEncontrada(nombreArea) {
      this.limpiarFiltro();
      this.temporalAlert({
        show: true,
        type: "warning",
        message: `El área "${nombreArea}" no está disponible.`
      });
      await this.buscar(this.search);
    },
    limpiarFiltro() {
      this.search.categoria = null;
      this.search.id_area_interes = null;
      this.search.id_institucion = null;
      this.search.id_establecimiento = null;
      this.search.fecha_inicio_publicacion = null;
      this.search.fecha_fin_publicacion = null;
      this.date = [];
      this.pagina = 1;
      this.buscar(this.search);
      const path = this.$route.path;
      window.history.pushState({}, "", path);
      this.$router.replace({ path }, () => {
        // console.log('URL actualizada a:', window.location.href);
      });
    },
    // Recibe el filtro emitido por AppFiltro y ejecuta la búsqueda
    onActualizarFiltro(filtro) {
      const rango = filtro.rangoFechasPublicacion || {};
      this.search.id_area_interes = filtro.area_interes;
      this.search.id_institucion = filtro.institucion;
      this.search.id_establecimiento = filtro.establecimiento;
      this.search.fecha_inicio_publicacion = rango.fechaInicio || null;
      this.search.fecha_fin_publicacion = rango.fechaFin || null;
      this.pagina = 1;
      this.buscar(this.search);
    },
    onLimpiarFiltro() {
      this.limpiarFiltro();
    },
    // async getAreaInteres() {
    //   this.loading = true;
    //   const response = await this.services.OfertaEmpleo.getAreaInteres();
    //   if (response.status == 200) {
    //     this.areaInteres = response.data;
    //   }
    //   this.loading = false;
    // },
    async getListOfertasEmpleos() {
      let fav_id_persona = this.dataPersona.id;
      let params = {
        per_page: this.per_page,
        page: this.pagina,
        pagination: true
      };
      const response = await this.services.OfertaEmpleo.getOfertasEmpleos(
        fav_id_persona,
        params
      );
      if (response.status == 200) {
        this.ListOfertaEmplos = response.data.data;
        this.empleos = this.ListOfertaEmplos?.length;
        this.per_page = response.data?.pagination.per_page;
        this.totalRegistros = response?.data.pagination.total_rows;
        this.establecimientos = response.data?.establecimiento;
        this.instituciones = response.data?.instituciones;
        this.areaInteres = response.data?.area_de_interes;
        this.pagina = parseInt(response.data?.pagination.page);
      }
    },
    async getObtenerPaginacion() {
      let params = {
        per_page: this.per_page,
        page: this.pagina,
        pagination: true
      };
      const response = await this.services.OfertaEmpleo.getPaginacionEmpleos(
        params
      );
      if (response.status == 200) {
        this.ListOfertaEmplos = response.data;
        this.empleos = this.ListOfertaEmplos?.length;
        this.per_page = response.pagination.per_page;
        this.totalRegistros = response.pagination.total_rows;
        this.pagina = parseInt(response.pagination.page);
      }
    },
    async getListOfertasEmpleosSugeridos() {
      const response =
        await this.services.OfertaEmpleo.getOfertasEmpleoSugeridos(
          this.dataPersona.id
        );
      this.ListOfertaEmplosSugeridos = response.data;
      // console.log("respuesta-seguerido",this.ListOfertaEmplosSugeridos)
    },
    iniciarSesion() {
      this.$router.push({ name: "login" });
    },
    async goToIdentidadDigital(url) {
      // console.log(url);
      window.open(url, "_parent");
    },
    async buscar(search) {
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
      }
      this.debounceTimer = setTimeout(async () => {
        this.loading = true;
        const filter = {};
        let fav_id_persona = this.dataPersona.id;
        filter.nombre_oferta = search?.categoria;
        filter.id_area_interes = search?.id_area_interes;
        filter.id_institucion = search?.id_institucion;
        filter.id_establecimiento = search?.id_establecimiento;
        filter.fecha_inicio_publicacion = search?.fecha_inicio_publicacion;
        filter.fecha_fin_publicacion = search?.fecha_fin_publicacion;
        filter.per_page = this.per_page;
        filter.page = this.page;
        filter.pagination = true;
        const response = await this.services.OfertaEmpleo.getOfertasEmpleos(
          fav_id_persona,
          filter
        );
        this.ListOfertaEmplos = response.data.data;
        this.per_page = response.data?.pagination.per_page;
        this.totalRegistros = response?.data.pagination.total_rows;
        this.pagina = parseInt(response.data?.pagination.page);
        this.empleos =
          this.ListOfertaEmplos?.length > 0 ? this.ListOfertaEmplos?.length : "0";
        this.loading = false;
      }, 500);
    },
    regresar() {
      this.$router.push({ name: "inicio" });
    },
    async getNivelExperiencia() {
      const response = await this.services.OfertaEmpleo.getNivelExperiencia();
      this.cheackExperiencia = response.data;
    },
    async getTipoHorario() {
      const response = await this.services.OfertaEmpleo.getTipoHorario();
      this.cheackHorario = response.data;
    },

    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },

    setDate(date) {
      this.date = date;
    },

    formatDate(date) {
      this.setDate(date);
      if (Array.isArray(date) && date.length > 0) {
        if (date.length === 1) {
          // El arreglo contiene solo un valor
          var dateVar = date[0]; // Puedes acceder al valor usando miArreglo[0]
          if (!dateVar) return null;

          const [year, month, day] = dateVar.split("-");
          return `${day}/${month}/${year}`;
        } else {
          // El arreglo no contiene exactamente un valor
          const [yearSD, monthSD, daySD] = date[0].split("-");
          const [yearED, monthED, dayED] = date[1].split("-");
          return `${daySD}/${monthSD}/${yearSD} ~ ${dayED}/${monthED}/${yearED}`;
        }
      }
    },

    validarTecla(event) {
      const char = event.key;
      if (
        event.keyCode === 8 ||
        event.keyCode === 9 ||
        event.keyCode === 13 ||
        event.keyCode === 46
      ) {
        return true;
      }

      const regex = /^[a-zA-ZáéíóúÁÉÍÓÚñÑüÜ\s]$/;

      if (!regex.test(char)) {
        event.preventDefault();
        return false;
      }
    },

    validarCategoria() {
      if (this.search.categoria) {
        this.search.categoria = this.search.categoria
          .replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑüÜ\s]/g, "")
          .replace(/\s+/g, " ");
      }
    },

    handlePaste(event) {
      // Prevenir el pegado por defecto
      event.preventDefault();

      const pastedText = (event.clipboardData || window.clipboardData).getData(
        "text"
      );

      const cleanedText = pastedText
        .replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑüÜ\s]/g, "")
        .replace(/\s+/g, " ");

      if (cleanedText) {
        this.search.categoria = cleanedText;
      }
    },

    handleResize() {
      this.windowWidth = window.innerWidth;
    },
    cerrarModalRegistro() {
      this.modalRegistro = false;
    },
  },
  watch: {
    "$route.query"(newQuery) {
      if (newQuery.area !== this.$route.query.area) {
        this.manejarCambioQuery(newQuery);
      }
    }
  },
  watch: {
    "search.id_area_interes": function (newVal, oldVal) {
      if (newVal === null && oldVal !== null) {
        this.limpiarFiltro();
      }
    },
    date(val) {
      this.dateFormatted = this.formatDate(val);
      return val;
    }
  },
  async created() {
    // await this.getAreaInteres();
    const busquedaEjecutada = await this.manejarCambioQuery(this.$route.query);
    if (!busquedaEjecutada) {
      await this.getListOfertasEmpleos();
    }
    this.token = localStorage.getItem("token");
    if (this.token) {
      const userDecode = jwtDecode(this.token);
      this.dataPersona = userDecode.persona;
    }
    if (this.dataPersona?.hasOwnProperty("id")) {
      //await this.getListOfertasEmpleosSugeridos();
    }
    await this.getNivelExperiencia();
    await this.getTipoHorario();
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  }
};
</script>

<style scoped>
.hero-gradient {
  background: linear-gradient(90deg,
      #F6F6F6 0%,
      #F6F6F6 50%,
      #DBDBDB 100%);
}

.custom-title-text {
  font-weight: 600;
  font-size: 72px;
  line-height: 60px;
  letter-spacing: -0.5px;
  vertical-align: middle;
}

.custom-filter-text {
  font-weight: 600;
  font-size: 32px;
  line-height: 40px;
  letter-spacing: 0.25px;
  vertical-align: middle;
}

.custom-subtitle-text {
  font-weight: 600;
  font-size: 34px;
  line-height: 40px;
  letter-spacing: 0.25px;
  vertical-align: middle;
}

::v-deep .principalPagination>>>.pagination {
  display: block !important;
}

.my-button:hover {
  background-color: #333458;
  color: white;
}

.margen-arriba {
  margin-top: 15rem;
}

@media (max-width: 1264px) {
  .margen-arriba {
    margin-top: 1rem;
  }

  .custom-title-text {
    font-weight: 600;
    font-size: 3em !important;
    line-height: 60px;
    letter-spacing: -0.5px;
    vertical-align: middle;
  }
}

.wave {
  background: url(../../assets/img/wave.svg);
  width: 100% !important;
  background-size: cover;
}

.postulaciones-container {
  display: grid;
  grid-template-columns: repeat(3, 33.33%);
  grid-gap: 1.5rem;
  margin-top: 50px;
}

@media (max-width: 1024px) {
  .postulaciones-container {
    grid-template-columns: repeat(1, 100%);
  }

  .custom-title-text {
    font-weight: 600;
    font-size: 2em !important;
    line-height: 60px;
    letter-spacing: -0.5px;
    vertical-align: middle;
  }
}

@media (max-width: 1330px) {
  .postulaciones-container {
    grid-template-columns: repeat(2, 50%);
  }

  .custom-title-text {
    font-weight: 600;
    font-size: 3em !important;
    line-height: 60px;
    letter-spacing: -0.5px;
    vertical-align: middle;
  }
}

.margin-top-50 {
  margin-top: 50px;
}

/* .postulaciones {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  grid-gap: 2rem;
  margin-top: 50px;
} */

/* @media (max-width: 1024px) {
  .postulaciones-container {
    grid-template-columns: repeat(auto-fit, minmax(500px, 1fr));
  }
} */
.text-primary-color {
  color: #22234a !important;
}

.my-pagination .v-pagination__item {
  background-color: #333458;
  color: #30a4f1;
  border-radius: 100%;
}

.my-pagination .v-pagination__item--active {
  background-color: red;
}

@media (max-width: 600px) {
  .centra-movil {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    word-break: break-word;
  }
}

.search-container {
  background-color: white;
  border-radius: 50px;
  padding: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.search-input {
  flex: 1;
  margin: 0 !important;
  padding: 0 !important;
}

.search-input ::v-deep .v-input__control {
  min-height: 48px !important;
}

.search-input ::v-deep .v-input__slot {
  margin-bottom: 0 !important;
  padding: 0 12px !important;
}

.search-button {
  text-transform: none !important;
  margin-left: 8px !important;
  padding: 0 32px !important;
  height: 48px !important;
  font-weight: 500;
  letter-spacing: 0.5px;
}

.search-input ::v-deep .v-input__append-inner .v-icon {
  color: #22234a !important;
}

.padding-hero {
  padding-top: 151px;
}

@media screen and (min-width: 801px) and (max-width: 1064) {
  .padding-hero {
    padding-top: 0px;
  }

  .custom-title-text {
    font-weight: 600;
    font-size: 1em;
    line-height: 60px;
    letter-spacing: -0.5px;
    vertical-align: middle;
  }
}

@media screen and (max-width: 800px) {
  .padding-hero {
    padding-top: 4rem;
  }
}

@media screen and (max-width: 460px) {
  .padding-hero {
    padding-top: 6rem;
  }
}
</style>
